import loadDayViewItems from './internal/loadDayViewItems';
import { addDays, isSameDay, userDate } from 'owa-datetime';
import { loadDayView } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrator which listens to the event loadDayView and calls the appropriate function based on actionMessage.
 */
export default orchestrator(loadDayView, actionMessage => {
    const { pivotDate, eventsAddedOrRemoved } = actionMessage;
    if (!eventsAddedOrRemoved) {
        loadDayViewItems(pivotDate, Date.now());
    } else {
        // Need to check if reload is needed as eventsAddedOrRemoved can be present even when reload is not needed.
        let isLoadDayViewNeeded = false;
        if (eventsAddedOrRemoved) {
            // event when we have an empty array we must load all the agendaItems
            for (const event of eventsAddedOrRemoved) {
                const eventDate = userDate(event.timestamp);

                if (
                    isSameDay(eventDate, pivotDate) ||
                    isSameDay(eventDate, addDays(pivotDate, 1)) ||
                    isSameDay(eventDate, addDays(pivotDate, -1))
                ) {
                    isLoadDayViewNeeded = true;
                    break;
                }
            }
        }

        if (isLoadDayViewNeeded) {
            loadDayViewItems(pivotDate, Date.now());
        }
    }
});
